export default __webpack_public_path__ + "static/media/data_(2)_activa-instrumentos.8745de53.png";